import type { ErrorEvent, Event } from '@sentry/react'
import type { AxiosError } from 'axios'
import { isAxiosError } from 'axios'

const addAxiosErrorContextRecursive = (event: ErrorEvent, error: unknown) => {
  if (isAxiosError(error)) {
    addAxiosErrorContext(event, error)
  } else if (error instanceof Error && error.cause) {
    addAxiosErrorContextRecursive(event, error.cause)
  }
}

const addAxiosErrorContext = (event: Event, error: AxiosError) => {
  const contexts = { ...event.contexts }
  contexts.AxiosError = {
    Message: error.message,
    Name: error.name,
    Stack: error.stack,
    Code: error.code,
    Config: error.config,
    Request: error.request,
    Response: error.response,
    Status: error.status,
    IsAxiosError: error.isAxiosError,
  }
  event.contexts = contexts
}

export default addAxiosErrorContextRecursive
